import { render } from "./SearchByTopicComponent.vue?vue&type=template&id=256e4ac6&scoped=true"
import script from "./SearchByTopicComponent.vue?vue&type=script&lang=js"
export * from "./SearchByTopicComponent.vue?vue&type=script&lang=js"

import "./SearchByTopicComponent.vue?vue&type=style&index=0&id=256e4ac6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256e4ac6"]])

export default __exports__